import {isObject} from 'lodash'
import { useEffect, useState } from 'react'
import feathers from 'utility/client'

export const Select = props => {
  const {
    service,
    query = {},
    textProperty = 'name',
    valueProperty = '_id',
    value,
    title = 'Select',
    onChange = () => {},
    InputProps = {},
    prependItems = [],
    onResult = (data) => data
  } = props

  const [list, setList] = useState([])

  const hydrate = () => {
    feathers.service(service).find({
      query: {
        ...query,
        $limit: -1
      }
    }).then(data => {
      setList([...prependItems, ...onResult(data)])
      console.log(`Select:: ${data.length} ${service} items loaded`)
    })
  }

  useEffect(() => {
    hydrate()
  }, [])

  return (
    <select
      className="form-control"
      onChange={onChange}
      value={isObject(value) ? value[valueProperty] : value}
      {...InputProps}
    >
      <option selected={value} value="" disabled>
        {title}
      </option>
      {list.map(i => (
        <option
          key={i[valueProperty]}
          value={i[valueProperty]}
          selected={i[valueProperty] === (isObject(value) ? value[valueProperty] : value)}
        >
          {i[textProperty]}
        </option>
      ))}
    </select>
  )
}
